/* ============================================================
   NOMAD QUICK ADD  v8
   - Regular cards: single size → add to cart
   - Pair cards: one OR both sizes → add selected items to cart
   ============================================================ */

console.log('%c[NOMAD QA] v8 loaded', 'background:#111;color:#0f0;padding:2px 6px;border-radius:3px');

(function() {
  'use strict';

  /* ========== CAPTURE-PHASE CLICK INTERCEPTION ========== */

  document.addEventListener('click', function(e) {
    var regSize = e.target.closest('[data-nomad-size]');
    var regAdd = e.target.closest('[data-nomad-add]');
    var pairSize = e.target.closest('[data-nomad-pcard-size]');
    var pairAdd = e.target.closest('[data-nomad-pcard-add]');

    if (!regSize && !regAdd && !pairSize && !pairAdd) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    if (regSize && !regSize.disabled) {
      toggleSize(regSize);
    } else if (regAdd && !regAdd.disabled) {
      tryAddToCart(regAdd);
    } else if (pairSize && !pairSize.disabled) {
      togglePairSize(pairSize);
    } else if (pairAdd && !pairAdd.disabled) {
      tryPairAddToCart(pairAdd);
    }
  }, true);

  ['mousedown', 'touchstart', 'pointerdown'].forEach(function(evtName) {
    document.addEventListener(evtName, function(e) {
      if (e.target.closest('[data-nomad-size], [data-nomad-add], [data-nomad-pcard-size], [data-nomad-pcard-add]')) {
        e.stopPropagation();
      }
    }, true);
  });

  /* ========== CARD NAVIGATION ========== */

  function bindCardNav() {
    document.querySelectorAll('.product-item').forEach(function(card) {
      if (card.dataset.nomadNavBound === '1') return;
      if (!card.querySelector('.nomad-qa')) return;
      card.dataset.nomadNavBound = '1';

      var link = card.querySelector('.product-item__special-link');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;

      var zones = card.querySelectorAll('.box--product-image, .caption > div:first-child');
      zones.forEach(function(zone) {
        zone.style.cursor = 'pointer';
        zone.addEventListener('click', function(e) {
          if (e.target.closest('[data-nomad-qa], [data-nomad-qa-pair]')) return;
          window.location.href = href;
        });
      });
    });
  }

  /* ================================================================
     REGULAR CARD LOGIC
     ================================================================ */

  function toggleSize(btn) {
    var card = btn.closest('[data-nomad-qa]');
    if (!card) return;

    var wasSelected = btn.classList.contains('is-selected');
    var addBtn = card.querySelector('[data-nomad-add]');
    var status = card.querySelector('[data-nomad-status]');

    card.querySelectorAll('[data-nomad-size]').forEach(function(b) {
      b.classList.remove('is-selected');
    });

    if (wasSelected) {
      delete card.dataset.selectedVariant;
      if (addBtn) addBtn.disabled = true;
    } else {
      btn.classList.add('is-selected');
      card.dataset.selectedVariant = btn.dataset.variantId;
      if (addBtn) addBtn.disabled = false;
    }

    if (status) status.textContent = '';
  }

  function clearCardSelection(card) {
    card.querySelectorAll('[data-nomad-size]').forEach(function(b) {
      b.classList.remove('is-selected');
    });
    delete card.dataset.selectedVariant;
    var addBtn = card.querySelector('[data-nomad-add]');
    if (addBtn) addBtn.disabled = true;
  }

  function tryAddToCart(btn) {
    var card = btn.closest('[data-nomad-qa]');
    if (!card) return;

    var status = card.querySelector('[data-nomad-status]');
    var variantId = card.dataset.selectedVariant;

    if (!variantId) {
      if (status) status.textContent = 'Select a size';
      return;
    }
    addToCart(card, btn, status, [{ id: parseInt(variantId, 10), quantity: 1 }]);
  }

  /* ================================================================
     PAIR CARD LOGIC — enables with ONE or BOTH sizes selected
     ================================================================ */

  function togglePairSize(btn) {
    var card = btn.closest('[data-nomad-qa-pair]');
    if (!card) return;

    var group = btn.dataset.group;
    var groupContainer = card.querySelector('[data-pair-group="' + group + '"]');
    if (!groupContainer) return;

    var wasSelected = btn.classList.contains('is-selected');

    groupContainer.querySelectorAll('[data-nomad-pcard-size]').forEach(function(b) {
      b.classList.remove('is-selected');
    });

    if (wasSelected) {
      delete card.dataset['selected_' + group];
    } else {
      btn.classList.add('is-selected');
      card.dataset['selected_' + group] = btn.dataset.variantId;
    }

    // Enable Add to cart if AT LEAST ONE size is selected
    var addBtn = card.querySelector('[data-nomad-pcard-add]');
    var status = card.querySelector('[data-nomad-pcard-status]');
    if (addBtn) {
      addBtn.disabled = !(card.dataset.selected_top || card.dataset.selected_legging);
    }
    if (status) status.textContent = '';
  }

  function tryPairAddToCart(btn) {
    var card = btn.closest('[data-nomad-qa-pair]');
    if (!card) return;

    var status = card.querySelector('[data-nomad-pcard-status]');
    var topId = card.dataset.selected_top;
    var legId = card.dataset.selected_legging;

    if (!topId && !legId) {
      if (status) status.textContent = 'Select a size';
      return;
    }

    // Build items array with only the selected sizes
    var items = [];
    if (topId) items.push({ id: parseInt(topId, 10), quantity: 1 });
    if (legId) items.push({ id: parseInt(legId, 10), quantity: 1 });

    addToCart(card, btn, status, items, true);
  }

  /* ================================================================
     SHARED ADD TO CART
     ================================================================ */

  function addToCart(card, addBtn, status, items, isPair) {
    addBtn.classList.add('is-loading');
    addBtn.disabled = true;
    if (status) status.textContent = 'Adding...';

    var route = '/cart/add.js';
    if (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_add_url) {
      route = KROWN.settings.routes.cart_add_url;
    }

    fetch(route, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err) { throw err; });
      return res.json();
    })
    .then(function() {
      addBtn.classList.remove('is-loading');
      addBtn.classList.add('is-added');
      if (status) status.textContent = 'Added';

      refreshCartDrawerAndOpen();

      setTimeout(function() {
        addBtn.classList.remove('is-added');
        if (status) status.textContent = '';

        if (isPair) {
          card.querySelectorAll('[data-nomad-pcard-size]').forEach(function(b) {
            b.classList.remove('is-selected');
          });
          delete card.dataset.selected_top;
          delete card.dataset.selected_legging;
          addBtn.disabled = true;
        } else {
          clearCardSelection(card);
        }
      }, 1500);
    })
    .catch(function(err) {
      addBtn.classList.remove('is-loading');
      addBtn.disabled = false;
      var msg = (err && err.description) ? err.description : 'Error, try again';
      if (status) status.textContent = msg;
      console.error('[NOMAD QA] Cart add failed:', err);
    });
  }

  /* ========== CART DRAWER REFRESH + OPEN ========== */

  function refreshCartDrawerAndOpen() {
    fetch(window.location.href, {
      headers: { 'Accept': 'text/html' },
      cache: 'no-cache'
    })
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newInner = doc.querySelector('#site-cart .site-nav-container-last');
      var currentInner = document.querySelector('#site-cart .site-nav-container-last');
      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }

      var countSelectors = [
        '#site-cart-handle .count',
        '#site-cart-handle span',
        '[data-js-cart-count]',
        '.site-cart-count',
        '.cart-count',
        '[data-cart-count]'
      ];
      countSelectors.forEach(function(sel) {
        var newEls = doc.querySelectorAll(sel);
        var curEls = document.querySelectorAll(sel);
        if (newEls.length && curEls.length && newEls.length === curEls.length) {
          newEls.forEach(function(newEl, i) {
            if (curEls[i] && newEl.textContent !== curEls[i].textContent) {
              curEls[i].textContent = newEl.textContent;
            }
          });
        }
      });

      openCartDrawer();
    })
    .catch(function(err) {
      console.error('[NOMAD QA] Drawer refresh failed:', err);
      openCartDrawer();
    });
  }

  function openCartDrawer() {
    try {
      document.dispatchEvent(new CustomEvent('krown:cart:add', {
        bubbles: true,
        detail: { source: 'nomad-quick-add' }
      }));
    } catch (e) {}

    var drawer = document.querySelector('#site-cart, [data-js-site-cart-sidebar]');
    if (drawer) {
      if (typeof drawer.show === 'function') {
        try { drawer.show(); return; } catch (e) {}
      }
      if (typeof drawer.open === 'function') {
        try { drawer.open(); return; } catch (e) {}
      }
    }

    var cartHandle = document.querySelector(
      '#site-cart-handle, [data-js-site-cart-handle], .site-cart-handle, a[href$="/cart"]'
    );
    if (cartHandle) {
      try { cartHandle.click(); } catch (e) {}
    }
  }

  /* ========== INIT ========== */

  function init() {
    console.log('[NOMAD QA] init() — regular:', document.querySelectorAll('[data-nomad-qa]').length, 'pair:', document.querySelectorAll('[data-nomad-qa-pair]').length);
    bindCardNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('krown:main-collection-grid:filtered', init);
  document.addEventListener('shopify:section:load', init);

})();